import React, { FunctionComponent } from 'react';

import { PrimaryButton } from '@components/library/button/index';
import { FontData } from '@api/v4/assets/assetTypes';

interface FontLinkProps {
  assetData: FontData;
  assetName: string;
}

const FontLink: FunctionComponent<FontLinkProps> = ({
  assetData,
  assetName,
}) => {
  const fontSource = (): string => {
    if (assetData.web_font_id && assetData.web_font_type === "google") {
      return bfTranslate('Google Fonts');
    }

    if (assetData.web_font_id && assetData.web_font_type === "adobe") {
      return bfTranslate('Adobe Fonts');
    }

    return "Fonts.com";
  };

  const fontUrl = (): string => {
    const fontName = assetName.replace(/\s+/g, "+").toLowerCase();
    const fontId = assetData.web_font_id.replace(/\s+/g, "+");

    if (assetData.web_font_id && assetData.web_font_type === "google") {
      return `https://fonts.google.com/specimen/${fontId}`;
    }

    if (assetData.web_font_id && assetData.web_font_type === "adobe") {
      return `https://edgewebfonts.adobe.com/fonts#/?collection=${assetData.web_font_id}`;
    }

    return `http://www.fonts.com/search/all-fonts?searchtext=${fontName}`;
  };

  return (
    <PrimaryButton
      icon="bff-font-type"
      onClick={(): void => { window.open(fontUrl(), '_blank'); }}
      size="medium"
    >
      {fontSource()}
    </PrimaryButton>
  );
};

export default FontLink;
